var map = {
	"./CSRealCase1-en-moblie.jpg": 888,
	"./CSRealCase1-en.jpg": 889,
	"./CSRealCase1-moblie.jpg": 890,
	"./CSRealCase1.jpg": 891,
	"./CSRealCase2-en-moblie.jpg": 892,
	"./CSRealCase2-en.jpg": 893,
	"./CSRealCase2-moblie.jpg": 894,
	"./CSRealCase2.jpg": 895,
	"./CSRealCase3-en-moblie.jpg": 896,
	"./CSRealCase3-en.jpg": 897,
	"./CSRealCase3-moblie.jpg": 898,
	"./CSRealCase3.jpg": 899,
	"./CommonInternetWhalingAttacks1.jpg": 900,
	"./CommonInternetWhalingAttacks2.jpg": 901,
	"./CommonInternetWhalingAttacks3.jpg": 902,
	"./CommonInternetWhalingAttacks4.jpg": 903,
	"./CustomerRealCase1-en-moblie.jpg": 904,
	"./CustomerRealCase1-en.jpg": 905,
	"./CustomerRealCase1-moblie.jpg": 906,
	"./CustomerRealCase1.jpg": 907,
	"./E-commerceRealCase1-en.jpg": 908,
	"./E-commerceRealCase1-moblie-en.jpg": 909,
	"./E-commerceRealCase1-moblie.jpg": 910,
	"./E-commerceRealCase1.jpg": 911,
	"./E-commerceRealCase2-en.jpg": 912,
	"./E-commerceRealCase2-mobile.jpg": 913,
	"./E-commerceRealCase2-moblie-en.jpg": 914,
	"./E-commerceRealCase2-moblie.jpg": 915,
	"./E-commerceRealCase2.jpg": 916,
	"./FinanceRealCase-en.jpg": 917,
	"./FinanceRealCase-mobile-en.jpg": 918,
	"./FinanceRealCase-mobile-sc.jpg": 919,
	"./FinanceRealCase-mobile.jpg": 920,
	"./FinanceRealCase-sc.jpg": 921,
	"./FinanceRealCase.jpg": 922,
	"./FinanceRealCase2-en.jpg": 923,
	"./FinanceRealCase2-mobile-en.jpg": 924,
	"./FinanceRealCase2-mobile-sc.jpg": 925,
	"./FinanceRealCase2-mobile.jpg": 926,
	"./FinanceRealCase2-sc.jpg": 927,
	"./FinanceRealCase2.jpg": 928,
	"./HRRealCase-en.jpg": 929,
	"./HRRealCase-mobile-en.jpg": 930,
	"./HRRealCase-mobile.jpg": 931,
	"./HRRealCase.jpg": 932,
	"./ITRealCase1-en.jpg": 933,
	"./ITRealCase1-moblie-en.jpg": 934,
	"./ITRealCase1-moblie.jpg": 935,
	"./ITRealCase1.jpg": 936,
	"./ITRealCase2-en.jpg": 937,
	"./ITRealCase2-moblie-en.jpg": 938,
	"./ITRealCase2-moblie.jpg": 939,
	"./ITRealCase2.jpg": 940,
	"./ITRealCase3-en.jpg": 941,
	"./ITRealCase3-moblie-en.jpg": 942,
	"./ITRealCase3-moblie.jpg": 943,
	"./ITRealCase3.jpg": 944,
	"./IndexPrompt.jpg": 945,
	"./MarketRealCase.jpg": 946,
	"./MarketRealCase1-en-moblie.jpg": 947,
	"./MarketRealCase1-en.jpg": 948,
	"./MarketRealCase1-moblie.jpg": 949,
	"./MarketRealCase1.jpg": 950,
	"./MarketRealCase2-en-moblie.jpg": 951,
	"./MarketRealCase2-en.jpg": 952,
	"./MarketRealCase2-moblie.jpg": 953,
	"./MarketRealCase2.jpg": 954,
	"./MarketRealCase3-en.jpg": 955,
	"./NGORealCase1-en.jpg": 956,
	"./NGORealCase1-moblie-en.jpg": 957,
	"./NGORealCase1-moblie.jpg": 958,
	"./NGORealCase1.jpg": 959,
	"./NGORealCase2-en.jpg": 960,
	"./NGORealCase2-moblie-en.jpg": 961,
	"./NGORealCase2-moblie.jpg": 962,
	"./NGORealCase2.jpg": 963,
	"./RealCase-mobile-en.jpg": 964,
	"./RealCase-mobile-sc.jpg": 965,
	"./RealCase-sc.jpg": 966,
	"./RealCase.mobile.jpg": 967,
	"./Realcase-socialMedia-mobile.jpg": 968,
	"./Realcase-socialMedia.jpg": 969,
	"./a004-a.jpg": 970,
	"./a004-b.jpg": 971,
	"./a004-example1-en.jpg": 972,
	"./a004-example1-sc.jpg": 973,
	"./a004-example1.jpg": 974,
	"./a004-example2.jpg": 975,
	"./a004-example3.jpg": 976,
	"./a008-tip.jpg": 977,
	"./a009-tip1.jpg": 978,
	"./a009-tip2.jpg": 979,
	"./a009-tip3.jpg": 980,
	"./a011-01.jpg": 981,
	"./a011-010.jpg": 982,
	"./a011-011.jpg": 983,
	"./a011-012.jpg": 984,
	"./a011-02.jpg": 985,
	"./a011-03.jpg": 986,
	"./a011-04.jpg": 987,
	"./a011-05.jpg": 988,
	"./a011-06.jpg": 989,
	"./a011-07.jpg": 990,
	"./a011-08.jpg": 991,
	"./a011-09.jpg": 992,
	"./a011-example1.jpg": 993,
	"./a011-example2.jpg": 994,
	"./a011-example3.jpg": 995,
	"./a011-example5.jpg": 996,
	"./a011-example6.jpg": 997,
	"./a011-example7.jpg": 998,
	"./a011-example8.jpg": 999,
	"./a016-1.jpg": 1000,
	"./a016-2.jpg": 1001,
	"./a016-3.jpg": 1002,
	"./a016-4.jpg": 1003,
	"./a016-5.jpg": 1004,
	"./a016-6.jpg": 1005,
	"./a016-market-1.jpg": 1006,
	"./a016-market-2.jpg": 1007,
	"./a016-market-3.jpg": 1008,
	"./a016-market-4.jpg": 1009,
	"./a019-tip-en.jpg": 1010,
	"./a019-tip.jpg": 1011,
	"./a021-viewmore-en.jpg": 1012,
	"./a021-viewmore-fsi.jpg": 1013,
	"./a021-viewmore.jpg": 1014,
	"./a023-short1.jpg": 396,
	"./a023-short2.jpg": 397,
	"./a023-short3.jpg": 398,
	"./a023-short4.jpg": 399,
	"./a023-short5.jpg": 400,
	"./a023-short6.jpg": 401,
	"./a026-example1.jpg": 1053,
	"./a026-example2.jpg": 1054,
	"./a026-example3.jpg": 1055,
	"./a026-example4.jpg": 1056,
	"./a026-example5.jpg": 1057,
	"./a026-example6.jpg": 1058,
	"./a026-example7.jpg": 1059,
	"./a028-example1.jpg": 1066,
	"./a028-example2.jpg": 1067,
	"./a028-example3.jpg": 1068,
	"./a037-a.jpg": 1069,
	"./a037-b.jpg": 1070,
	"./a037-c.jpg": 1071,
	"./a037-d.jpg": 1072,
	"./a037-e.jpg": 1073,
	"./a037-f.jpg": 1074,
	"./a037-g.jpg": 1075,
	"./a037-h.jpg": 1076,
	"./a037-i.jpg": 1077,
	"./a037-j.jpg": 1078,
	"./a037-k.jpg": 1079,
	"./a037-l.jpg": 1080,
	"./a037-m.jpg": 1081,
	"./a037-n.jpg": 1082,
	"./aiSecurityRealcase-en.jpg": 1083,
	"./aiSecurityRealcase-mobile-en.jpg": 1084,
	"./aiSecurityRealcase-mobile.jpg": 1085,
	"./aiSecurityRealcase.jpg": 1086,
	"./c001-E-commerce-1.jpg": 1087,
	"./c001-E-commerce-2.jpg": 1088,
	"./c001-E-commerce-3.jpg": 1089,
	"./c001-E-commerce-4.jpg": 1090,
	"./c001-E-commerce-5.jpg": 1091,
	"./c001-E-commerce-6.jpg": 1092,
	"./c001-Picture1.jpg": 1093,
	"./c001-Picture2.jpg": 1094,
	"./c001-Picture3.jpg": 1095,
	"./c001-fsi-1.jpg": 1096,
	"./c001-fsi-2.jpg": 1097,
	"./c001-fsi-3.jpg": 1098,
	"./c001-fsi-4.jpg": 1099,
	"./c001-ngo-1.jpg": 1100,
	"./c001-ngo-2.jpg": 1101,
	"./c001-ngo-3.jpg": 1102,
	"./c001-ngo-4.jpg": 1103,
	"./c001-ngo-5.jpg": 1104,
	"./c001-student-1.jpg": 1105,
	"./c001-student-2.jpg": 1106,
	"./c001-student-3.jpg": 1107,
	"./c001-student-4.jpg": 1108,
	"./c001-student-5.jpg": 1109,
	"./c001-student-6.jpg": 1110,
	"./c001-student-7.jpg": 1111,
	"./c001-student-8.jpg": 1112,
	"./c002-example1.jpg": 1113,
	"./c002-general2024-example1.jpg": 1114,
	"./c006-1.jpg": 1115,
	"./c006-2.jpg": 1116,
	"./c006-3.jpg": 1117,
	"./c006-4.jpg": 1118,
	"./c006-5.jpg": 1119,
	"./c006-6.jpg": 1120,
	"./c006-a.jpg": 1121,
	"./c006-b.jpg": 1122,
	"./c006-c.jpg": 1123,
	"./c006-d.jpg": 1124,
	"./c007-1.jpg": 1125,
	"./c007-bg.jpg": 1126,
	"./cert/cert-E-commerce-HKIRC.jpg": 1127,
	"./cert/cert-E-commerce-consumer.jpg": 1128,
	"./cert/cert-E-commerce-cpttm.jpg": 1129,
	"./cert/cert-E-commerce-hkgcsmeaa.jpg": 402,
	"./cert/cert-customer-HKIRC.jpg": 1130,
	"./cert/cert-customer-consumer.jpg": 1131,
	"./cert/cert-customer-cpttm.jpg": 1132,
	"./cert/cert-customer-hkgcsmeaa.jpg": 403,
	"./cert/cert-finance-HKIRC-sc.jpg": 1133,
	"./cert/cert-finance-HKIRC.jpg": 1134,
	"./cert/cert-finance-consumer-sc.jpg": 1135,
	"./cert/cert-finance-consumer.jpg": 1136,
	"./cert/cert-finance-cpttm-sc.jpg": 1137,
	"./cert/cert-finance-cpttm.jpg": 1138,
	"./cert/cert-finance-hkgcsmeaa-sc.jpg": 404,
	"./cert/cert-finance-hkgcsmeaa.jpg": 405,
	"./cert/cert-fsi-HKIRC-sc.jpg": 1139,
	"./cert/cert-fsi-HKIRC.jpg": 1140,
	"./cert/cert-fsi-consumer-sc.jpg": 1141,
	"./cert/cert-fsi-consumer.jpg": 1142,
	"./cert/cert-fsi-cpttm-sc.jpg": 1143,
	"./cert/cert-fsi-cpttm.jpg": 1144,
	"./cert/cert-fsi-hkgcsmeaa-sc.jpg": 406,
	"./cert/cert-fsi-hkgcsmeaa.jpg": 407,
	"./cert/cert-general-staff-HKIRC-sc.jpg": 1145,
	"./cert/cert-general-staff-HKIRC.jpg": 1146,
	"./cert/cert-general-staff-a-HKIRC-sc.jpg": 1147,
	"./cert/cert-general-staff-a-HKIRC.jpg": 1148,
	"./cert/cert-general-staff-a-consumer-sc.jpg": 1149,
	"./cert/cert-general-staff-a-consumer.jpg": 1150,
	"./cert/cert-general-staff-a-cpttm-sc.jpg": 1151,
	"./cert/cert-general-staff-a-cpttm.jpg": 1152,
	"./cert/cert-general-staff-a-hkgcsmeaa-sc.jpg": 408,
	"./cert/cert-general-staff-a-hkgcsmeaa.jpg": 409,
	"./cert/cert-general-staff-consumer-sc.jpg": 1153,
	"./cert/cert-general-staff-consumer.jpg": 1154,
	"./cert/cert-general-staff-cpttm-sc.jpg": 1155,
	"./cert/cert-general-staff-cpttm.jpg": 1156,
	"./cert/cert-general-staff-hkgcsmeaa-sc.jpg": 410,
	"./cert/cert-general-staff-hkgcsmeaa.jpg": 411,
	"./cert/cert-general2024-HKIRC-sc.jpg": 1157,
	"./cert/cert-general2024-HKIRC.jpg": 1158,
	"./cert/cert-general2024-consumer-sc.jpg": 1159,
	"./cert/cert-general2024-consumer.jpg": 1160,
	"./cert/cert-general2024-cpttm-sc.jpg": 1161,
	"./cert/cert-general2024-cpttm.jpg": 1162,
	"./cert/cert-general2024-hkgcsmeaa-sc.jpg": 338,
	"./cert/cert-general2024-hkgcsmeaa.jpg": 339,
	"./cert/cert-hr-HKIRC.jpg": 1163,
	"./cert/cert-hr-consumer.jpg": 1164,
	"./cert/cert-hr-cpttm.jpg": 1165,
	"./cert/cert-hr-hkgcsmeaa.jpg": 412,
	"./cert/cert-it-HKIRC.jpg": 1166,
	"./cert/cert-it-consumer.jpg": 1167,
	"./cert/cert-it-cpttm.jpg": 1168,
	"./cert/cert-it-hkgcsmeaa.jpg": 413,
	"./cert/cert-market-HKIRC.jpg": 1169,
	"./cert/cert-market-consumer.jpg": 1170,
	"./cert/cert-market-cpttm.jpg": 1171,
	"./cert/cert-market-hkgcsmeaa.jpg": 414,
	"./cert/cert-ngo-HKIRC.jpg": 1172,
	"./cert/cert-ngo-consumer.jpg": 1173,
	"./cert/cert-ngo-cpttm.jpg": 1174,
	"./cert/cert-ngo-hkgcsmeaa.jpg": 415,
	"./cert/cert-senior-manager-HKIRC-sc.jpg": 1175,
	"./cert/cert-senior-manager-HKIRC.jpg": 1176,
	"./cert/cert-senior-manager-consumer-sc.jpg": 1177,
	"./cert/cert-senior-manager-consumer.jpg": 1178,
	"./cert/cert-senior-manager-cpttm-sc.jpg": 1179,
	"./cert/cert-senior-manager-cpttm.jpg": 1180,
	"./cert/cert-senior-manager-hkgcsmeaa-sc.jpg": 416,
	"./cert/cert-senior-manager-hkgcsmeaa.jpg": 417,
	"./cert/cert-startup-HKIRC.jpg": 1181,
	"./cert/cert-startup-consumer.jpg": 1182,
	"./cert/cert-startup-cpttm.jpg": 1183,
	"./cert/cert-startup-hkgcsmeaa.jpg": 418,
	"./cert/cert-student-HKIRC-sc.jpg": 1184,
	"./cert/cert-student-HKIRC.jpg": 1185,
	"./cert/cert-student-consumer-sc.jpg": 1186,
	"./cert/cert-student-consumer.jpg": 1187,
	"./cert/cert-student-cpttm-sc.jpg": 1188,
	"./cert/cert-student-cpttm.jpg": 1189,
	"./cert/cert-student-hkgcsmeaa-sc.jpg": 419,
	"./cert/cert-student-hkgcsmeaa.jpg": 420,
	"./dataLeakageRealcase-en.jpg": 1190,
	"./dataLeakageRealcase-mobile-en.jpg": 1191,
	"./dataLeakageRealcase-mobile.jpg": 1192,
	"./dataLeakageRealcase.jpg": 1193,
	"./education/topic1000/panelData4.jpg": 354,
	"./education/topic1000/panelData6.jpg": 355,
	"./fsiRealCase1-en.jpg": 1194,
	"./fsiRealCase1-mobile-en.jpg": 1195,
	"./fsiRealCase1-mobile-sc.jpg": 1196,
	"./fsiRealCase1-mobile.jpg": 1197,
	"./fsiRealCase1-sc.jpg": 1198,
	"./fsiRealCase1.jpg": 1199,
	"./fsiRealCase2-en-mobile.jpg": 1200,
	"./fsiRealCase2-en.jpg": 1201,
	"./fsiRealCase2-mobile-sc.jpg": 1202,
	"./fsiRealCase2-mobile.jpg": 1203,
	"./fsiRealCase2-sc.jpg": 1204,
	"./fsiRealCase2.jpg": 1205,
	"./general2024RealCase1-en-mobile.jpg": 1206,
	"./general2024RealCase1-en.jpg": 1207,
	"./general2024RealCase1-mobile-sc.jpg": 1208,
	"./general2024RealCase1-mobile.jpg": 1209,
	"./general2024RealCase1-sc.jpg": 1210,
	"./general2024RealCase1.jpg": 1211,
	"./it900-a031-en.jpg": 1212,
	"./it900-a031.jpg": 1213,
	"./it900-a32-1.jpg": 1214,
	"./it900-a32-2.jpg": 1215,
	"./it900-a32-3.jpg": 1216,
	"./it930-a033-1.jpg": 1217,
	"./it930-a033-2.jpg": 1218,
	"./it930-a033-3.jpg": 1219,
	"./it930-a033-4.jpg": 1220,
	"./it930-a033-5-en.jpg": 1221,
	"./it930-a033-5.jpg": 1222,
	"./lady-right.jpg": 1223,
	"./man-right.jpg": 1224,
	"./man.jpg": 1225,
	"./news-mobile-en.jpg": 1226,
	"./news-mobile-sc.jpg": 1227,
	"./news-mobile.jpg": 1228,
	"./news-sc.jpg": 1229,
	"./news.jpg": 1230,
	"./ngo-a035-1.jpg": 1231,
	"./ngo-a035-2.jpg": 1232,
	"./ngo-a035-3.jpg": 1233,
	"./ngo-a035-4.jpg": 1234,
	"./ngo-a036-example.jpg": 1235,
	"./p-onprogress-B.jpg": 1236,
	"./s3-004.jpg": 1237,
	"./s3-005.jpg": 1238,
	"./s3-006.jpg": 1239,
	"./s3-007.jpg": 1240,
	"./s3-008.jpg": 1241,
	"./startupRealCase1-en.jpg": 1242,
	"./startupRealCase1-mobile-en.jpg": 1243,
	"./startupRealCase1-mobile.jpg": 1244,
	"./startupRealCase1.jpg": 1245,
	"./startupRealCase2-en.jpg": 1246,
	"./startupRealCase2-mobile-en.jpg": 1247,
	"./startupRealCase2-mobile.jpg": 1248,
	"./startupRealCase2.jpg": 1249,
	"./studentRealCase1-mobile-sc.jpg": 1250,
	"./studentRealCase1-sc.jpg": 1251,
	"./studentRealCase2-mobile-sc.jpg": 1252,
	"./studentRealCase2-sc.jpg": 1253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3522;